
import ExpertiseContact from "../components/contantPage/ExpertiseContact";

const Contact = () => {


  return (
    <>
    <ExpertiseContact />
    </>
  );
};

export default Contact;
